import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';

import CheckBox from './checkbox';
import { Utils } from '../../Api';

let findProductOption = function (product, productOptionToken) {
  return product.options.find(productOption => { return productOption.token === productOptionToken; });
};

export default class Product extends React.Component {
  static propTypes = {
    product: PropTypes.object.isRequired,
    collectionOptions: PropTypes.array.isRequired,
    onEdit: PropTypes.func,
    className: PropTypes.string,
    setActive: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.options = this.options.bind(this);
    this.images = this.images.bind(this);
    this.toggleSelected = this.toggleSelected.bind(this);
    this.toggleEditModal = this.toggleEditModal.bind(this);

    this.state = {
      groupEnabled: true,
      images: this.images(props.product)
    };
  }

  productOptionsHierarchy(product, productOption) {
    let productHierarchy = [ productOption ];

    let lastProductOption = productOption;
    while (lastProductOption && lastProductOption.parent_token) {
      lastProductOption = findProductOption(product, lastProductOption.parent_token);
      productHierarchy.push(lastProductOption);
    }

    return productHierarchy;
  }

  options() {
    let firstCollectionOption = this.props.collectionOptions[0];
    let firstProductOption = this.props.product.options.find(option => { return option.token === firstCollectionOption.product_option_token; });
    let firstProductOptionHierarchy = this.productOptionsHierarchy(this.props.product, firstProductOption);

    let styleHeader = firstProductOptionHierarchy
      .map(option => {
        return option.group_name;
      })
      .join(',');

    let returnValue = [];
    returnValue.push(<div key={this.props.product.token + '-options-header'} className="option-line-header">
      <span>{styleHeader}</span>
      <span>Units</span>
      <span>Cost</span>
    </div>);

    this.props.collectionOptions.forEach(
      collectionOption => {
        let productOption = this.props.product.options.find(option => { return option.token === collectionOption.product_option_token; });
        let productCharacteristics = [];

        if (this.props.product.options && this.props.product.options.length > 1) {
          let productHierarchy = this.productOptionsHierarchy(this.props.product, productOption);
          productCharacteristics = productHierarchy.map(option => {
            return option.name
          });
        }

        returnValue.push(<div key={collectionOption.product_option_token} className="option-line">
          <span>{productCharacteristics.join(', ')}</span>
          <span>{collectionOption.quantity}</span>
          <span>${Utils.formatCents(productOption.wholesale_price_cents * collectionOption.quantity)}</span>
        </div>);
      }
    );

    return returnValue;
  }

  images(product) {
    let images = [];

    product = product || this.props.product;
    if (!product) return images;

    product.images.forEach(image => { images.push(image); });
    product.options.forEach(product_option => {
      product_option.images.forEach(image => { images.push(image); });
    });

    return images;
  }

  toggleSelected(event) {
    event.preventDefault();
    if (this.props.setActive) this.props.setActive(this.props.product.token, !this.state.groupEnabled);
    this.setState({groupEnabled: !this.state.groupEnabled});
  }

  toggleEditModal(event) {
    if (!event.defaultPrevented && this.state.groupEnabled) {
      this.props.onEdit(this.props.product.token);
    }
  }

  render() {
    let classNames = [ 'collection-product-component' ];

    if (!this.props.product || !this.props.product.options || this.props.product.options.length <= 0) return <div>Invalid product</div>;

    if (!this.state.groupEnabled) classNames.push('disabled');
    if (this.props.className) classNames.push(this.props.className);

    let imageUrl = null;
    if (this.state.images && this.state.images.length > 0) {
      imageUrl = this.state.images[0].url;
    }

    let description = this.props.product.description || '';
    if (description.indexOf('.') > 0) {
      description = description.substr(0, description.indexOf('.') + 1);
    }

    return (
      <div className={classNames.join(' ')}>
        <div className="inner-wrapper collection-product-component-inner-wrapper" onClick={this.toggleEditModal}>
          <div className="disabled-mask" />
          <div className="image"><img role="presentation" src={imageUrl} /></div>
          <div className="info">
            <div className="name">{this.props.product.name}</div>
            <div className="description">{description}</div>
            <div className="pricing">
              <div className="unitprice">Unit Cost ${Utils.formatCents(this.props.product.options[0].wholesale_price_cents)}</div>
              <div className="srp">SRP ${Utils.formatCents(this.props.product.options[0].retail_price_cents)}</div>
              <div className="case-size">CASE SIZE {this.props.product.options[0].unit_multiplier}</div>
            </div>
          </div>
          <div className="options">
            <div className="header">INCLUDED ITEMS <span className="edit">Edit <FontAwesome name="pencil" /></span></div>
            {this.options()}
          </div>
          <CheckBox onClick={this.toggleSelected} value={this.state.groupEnabled} label="Include" />
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/collection/product.js
 **/